import { useForm, FormProvider } from 'react-hook-form';
import { API as yachts } from '../../module/yachts/api';
import YachtDashboard from '../../components/yachtDashboard/YachtDashboard';
import { Box, Paper, Typography } from '@mui/material';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AsyncAutocomplete from '../../components/form/components/AsyncAutocomplete.component';
import { getItem, saveItem } from '../../utility/Storage.utility';
import { Fragment, useEffect } from 'react';
import _ from 'lodash';
import { yupResolver } from '@hookform/resolvers/yup';
import { FilterConf } from '../../module/yachtDashboard/conf/Filter.conf';

const YachtSelectPage = () => {
  const { schema, initialState } = FilterConf;
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const watchYachtId = methods.watch('id_yacht');
  const yachtDashboard = getItem('yachtDashboard');
  const yacht = yachtDashboard && JSON.parse(yachtDashboard);

  useEffect(() => {
    if (watchYachtId === null) {
      saveItem('yachtDashboard', JSON.stringify({}));
    } else if (watchYachtId && watchYachtId?.id !== yacht?.id) {
      saveItem('yachtDashboard', JSON.stringify(watchYachtId));
    } else if (watchYachtId === undefined && yacht) {
      methods.setValue('id_yacht', yacht);
    }
  }, [yacht, watchYachtId, methods]);

  return (
    <FormProvider {...methods}>
      {_.isEmpty(watchYachtId) ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85vh',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 6,
              width: '100%',
              maxWidth: 500,
              borderRadius: 4,
              backgroundColor: 'white',
            }}
          >
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <DirectionsBoatIcon
                sx={{ fontSize: 40, color: 'primary.main', mr: 1 }}
              />
              <Typography variant='h5' color='primary' fontWeight='bold'>
                Choose a Yacht
              </Typography>
            </Box>
            <AsyncAutocomplete
              id='id_yacht'
              label='Yacht'
              name='id_yacht'
              api={yachts.select}
            />
          </Paper>
        </Box>
      ) : (
        <Fragment>
          <YachtDashboard
            yachtID={watchYachtId?.id}
            methods={methods}
            initialState={initialState}
          >
            <Box
              sx={{
                ml: { xs: 0, md: 1 },
                minWidth: { xs: '100%', md: '540px' },
              }}
            >
              <AsyncAutocomplete
                id='id_yacht'
                label='Yacht'
                name='id_yacht'
                api={yachts.select}
              />
            </Box>
          </YachtDashboard>
        </Fragment>
      )}
    </FormProvider>
  );
};

export default YachtSelectPage;
